<template>
  <div class="container">
    <el-button type="primary" size="medium" icon="el-icon-plus" @click="adds">新增</el-button>
    <el-table v-loading="loading" border :data="tableData" >
      <el-table-column type="index" align="center" />
      <el-table-column label="代理商名称" prop="companyName" align="center" min-width="160" :show-overflow-tooltip="true" />
      <el-table-column label="代理商层级" prop="companyPath" min-width="160" align="center" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column label="作用范围" prop="level" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
          <span v-if="scope.row.level =='1'">当前账号</span>
          <span v-if="scope.row.level =='2'">当前账号及下级</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="createUser" min-width="100" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="创建时间" prop="createTime" min-width="120" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="操作" align="center" min-width="70" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="text" icon="el-icon-eidt" v-hasPermi="['agent:dict:edit']" @click="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="text" icon="el-icon-circle-close" v-hasPermi="['agent:dict:del']" @click="del(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title" :visible.sync="dialog" :lock-scroll="false" width="700px" append-to-body v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" ref="form" :rules="rules">
        <el-form-item label="代理商名称:" prop="userId" label-width="100px">
          <el-select :disabled="!!form.id" v-model="form.userId" filterable placeholder="请选择代理商" clearable style="width:90%">
            <el-option v-for="(item,index) in agentData" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="作用范围:" prop="level" label-width="100px">
          <el-radio-group v-model="form.level">
            <el-radio label="1">当前账号</el-radio>
            <el-radio label="2">当前账号及下级</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="success" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { agentDictList , agentList , agentDictSave , agentDictUpdate , agentDictDel} from "@/api/api";
export default {
  name: "NoPhoneFreeProduct",
  data() {
    return {
      loading:false,
      tableData:[],
      title:'',
      dialog:false,
      form:{
        id:undefined,
        userId:undefined,
        dictValue:undefined
      },
      rules:{
        userId:[
          { required: true, message: "请选择代理商", trigger: "blur" }
        ],
        level:[
          { required: true, message: "请选择作用范围", trigger: "blur" }
        ],
      },
      agentData:[]
    };
  },
  methods:{
    initData(){
      let key = "NoPhoneFreeProduct";
      agentDictList({key}).then(res=>{
        this.tableData = res.data.data
      })
    },
    submitForm(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!!this.form.id) {
            agentDictUpdate(this.form).then(res=>{
              this.initData()
              this.dialog = false
            })
          }else{
            this.form.dictKey = 'NoPhoneFreeProduct'
            agentDictSave(this.form).then(res=>{
              this.initData()
              this.dialog = false
            })
          }
        }
      })
    },
    selectAgentList() {
      agentList().then(res => {
        this.agentData = res.data.data;
      });
    },
    adds(){
      this.dialog = true
      this.title = "新增赠送套餐免显手机号设置"
      this.form={level:'1'}
    },
    edit(row){
      this.dialog = true
      this.title = "修改赠送套餐免显手机号设置"
      let form = {
        id:row.id,
        userId : row.userId,
        level : row.level
      }
      this.form = form
    },
    //删除免显
    del(row){
      let id = row.id
      this.$confirm("此操作将删除此赠送套餐免显手机号设置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
			}).then(() => {
        agentDictDel({id}).then(res=>{
          this.$notify({
            title: '成功',
            message: '免显删除成功',
            type: 'success'
          });
          this.initData();
        })
      })
    }
  },
  created() {
    this.initData()
    this.selectAgentList()
  },
};
</script>